export const actionTypes = {
    TOGGLETOOLBAR:'TOGGLETOOLBAR',
}